import type { RouteDef } from '../../../dashboardDef.type';

type RouterResult = {
  router: RouteDef[];
  route: RouteDef | undefined;
  primary: RouteDef | undefined;
};

const getRouter = (router: RouteDef[], currentPath: string): RouterResult => {
  const resetActiveStates = (routes: RouteDef[]): void => {
    for (const item of routes) {
      item.sidebar.active = false;

      if (item.routes?.length) {
        for (const route of item.routes) {
          route.sidebar.active = false;

          if (route.routes) {
            for (const routeChild of route.routes) {
              routeChild.sidebar.active = false;

              if (routeChild.tabs) {
                for (const tab of routeChild.tabs) {
                  tab.sidebar.active = false;
                }
              }
            }
          }

          if (route.tabs) {
            for (const tab of route.tabs) {
              tab.sidebar.active = false;
            }
          }
        }
      }
    }
  };

  const routesMatch = (patternPath: string | undefined, path: string): boolean => {
    if (!patternPath) return false;
    if (patternPath === path) return true;

    const patternParts = patternPath.split('/');

    return path.split('/').every((pathPart, i) => {
      const patternPart = patternParts[i];
      return patternPart.startsWith(':') || pathPart === patternPart;
    });
  };

  const findMatchingRoutes = (path: string): RouterResult => {
    const newRouter: RouteDef[] = router;
    let currentRoute: RouteDef | undefined;
    let currentPrimary: RouteDef | undefined;

    // Reset all active states before finding matches
    resetActiveStates(newRouter);

    for (const item of newRouter) {
      if (item.routes?.length) {
        for (const route of item.routes) {
          if (route.routes) {
            for (const routeChild of route.routes) {
              if (routeChild.tabs) {
                for (const tab of routeChild.tabs) {
                  if (tab.url === path) {
                    tab.sidebar.active = true;
                    routeChild.sidebar.active = true;
                    route.sidebar.active = true;
                    item.sidebar.active = true;
                    currentRoute = tab;
                    currentPrimary = item;
                  }
                }
              }

              if (routeChild.url?.includes(':') ? routesMatch(routeChild.url, path) : routeChild.url === path) {
                item.sidebar.active = true;
                routeChild.sidebar.active = true;
                route.sidebar.active = true;
                currentRoute = routeChild;
                currentPrimary = item;
              }
            }
          }

          if (route.tabs) {
            for (const tab of route.tabs) {
              if (tab.url === path) {
                item.sidebar.active = true;
                route.sidebar.active = true;
                currentRoute = tab;
                currentPrimary = item;
              }
            }
          }

          if (route.url === path) {
            route.sidebar.active = true;
            item.sidebar.active = true;
            currentRoute = route;
            currentPrimary = item;
          }
        }
      }

      if (item.url === path) {
        item.sidebar.active = true;
        currentRoute = item;
        currentPrimary = item;
      }
    }

    return {
      router: newRouter,
      route: currentRoute,
      primary: currentPrimary,
    };
  };

  return findMatchingRoutes(currentPath);
};

export default getRouter;
